import { reportError } from '../ErrorReporting';

const trace = {};

const liveSessionLogger = {
    getMessagerTrace(messagerId) {
        if (!trace[messagerId]) {
            trace[messagerId] = [];
        }
        return trace[messagerId];
    },

    addEvent(messagerId, event) {
        const messagerTrace = this.getMessagerTrace(messagerId);
        messagerTrace.push({
            timestamp: Date.now(),
            time: new Date(),
            event,
        });
    },

    sortMessagerTrace(messagerTrace) {
        messagerTrace.sort((item1, item2) => item1.timestamp - item2.timestamp);
    },

    resetTrace(messagerId) {
        if (!trace[messagerId]) {
            trace[messagerId] = [];
        }
    },

    reportError(messagerId, error) {
        const messagerTrace = this.getMessagerTrace(messagerId);
        this.sortMessagerTrace(messagerTrace);
        reportError(error, messagerTrace);
    },
};

export default liveSessionLogger;
